export const en = {
    'empty-header': 'No keywords selected',
    'empty-text': 'Here you will see a list of keywords which you can add to your ad group',
    'remove-action': 'Clear the list',
    title: 'Keywords'
};
